<template>
  <div class="page_">
    <!-- <div class="notice_">
      <p>通知消息</p>
      <p v-for="item in noticeList" :key="item.id">{{item.title}}：{{item.content}}</p>
    </div> -->
    <div class="info_">
      <p class="tit tit_fz">{{ $t("index[0]") || "个人信息" }}</p>
      <div class="bottom_">
        <div class="card_">
          <img src="../assets/medilinkPC/cardback.png" alt="" />
          <a-row class="name_">
            <a-col :span="24" class="tit">{{ name }}</a-col>
          </a-row>
          <a-row class="name_">
            <a-col
              :span="24"
              class="tit card_fz"
              style="font-size:22px;font-weight:bold;"
              >{{ qrCode | filterCode }}</a-col
            >
          </a-row>
          <div class="date_ tit">
            {{ idValidDate }} {{ $t("index[1]") || "生效" }}
          </div>
        </div>
        <div class="insurance">
          <img src="../assets/medilinkPC/bx.png" alt="" />
          <div class="middle_">{{ $t("index[2]") || "保险信息" }}</div>
          <router-link :to="{ name: 'Account' }"
            ><div class="blue_">
              {{ $t("index[3]") || "查看" }}
            </div></router-link
          >
        </div>
        <div class="insurance">
          <img src="../assets/medilinkPC/info.png" alt="" />
          <div class="middle_">{{ $t("index[0]") || "个人信息" }}</div>
          <router-link :to="{ name: 'Info' }"
            ><div class="blue_">
              {{ $t("index[4]") || "修改" }}
            </div></router-link
          >
        </div>
      </div>
    </div>
    <div class="business_">
      <p class="tit tit_fz">{{ $t("index[5]") || "理赔办理" }}</p>
      <div class="all_item_">
        <div
          v-for="item in businessList1"
          :key="item.id"
          class="item"
          @click="doPolicyApply(item)"
        >
          <img :src="item.icon" alt="" />
          <div class="con_">
            <div class="second_fz">{{ item.txt }}</div>
            <div class="desc_">{{ item.desc }}</div>
          </div>
        </div>
      </div>
      <div class="all_item_">
        <div
          v-for="item in businessList2"
          :key="item.id"
          class="item"
          @click="doPolicyApply(item)"
        >
          <img :src="item.icon" alt="" />
          <div class="con_">
            <div class="second_fz">{{ item.txt }}</div>
            <div class="desc_">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="business_">
      <p class="tit tit_fz">{{ $t("index[6]") || "预授权办理" }}</p>
      <div class="all_item_">
        <div
          v-for="item in prelicensList1"
          :key="item.id"
          class="item"
          @click="doPolicyApply1(item)"
        >
          <img :src="item.icon" alt="" />
          <div class="con_">
            <div class="second_fz">{{ item.txt }}</div>
            <div class="desc_">{{ item.desc }}</div>
          </div>
        </div>
      </div>
      <div class="all_item_">
        <div
          v-for="item in prelicensList2"
          :key="item.id"
          class="item"
          @click="doPolicyApply1(item)"
        >
          <img :src="item.icon" alt="" />
          <div class="con_">
            <div class="second_fz">{{ item.txt }}</div>
            <div class="desc_">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot_">
      <p class="tit tit_fz">{{ $t("index[9]") || "预约挂号/体检" }}</p>
      <div class="item s_text" @click="toSubscribe()">
        <img src="../assets/medilinkPC/hospital.svg" alt="" />
        <span class="second_fz">{{
          $t("index[10]") || "点击可查询预约列表"
        }}</span>
        <!-- <span class="ml_ blue_">{{$t("index[3]")||"查看"}}</span> -->
      </div>
    </div>
    <div class="foot_">
      <p class="tit tit_fz">{{ $t("index[7]") || "直付医院列表" }}</p>
      <div class="item s_text" @click="toHospital()">
        <img src="../assets/medilinkPC/hospital.svg" alt="" />
        <span class="second_fz">{{
          $t("index[8]") || "点击可查询直付医院列表"
        }}</span>
        <!-- <span class="ml_ blue_">{{$t("index[3]")||"查看"}}</span> -->
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.page_ {
  color: #394155;
  width: 100%;
  .tit {
    font-weight: 500;
  }
  .tit_fz {
    font-size: 16px;
    font-weight: bold;
  }
  .second_fz {
    font-size: 14px;
    font-weight: bold;
  }
  .card_fz {
    font-size: 16px;
  }
  .blue_ {
    color: #2c5acc;
  }
  .ml_ {
    cursor: pointer;
    margin-left: 33px;
  }
  .notice_ {
    background-color: #fff;
    width: 100%;
    height: 103px;
    border-radius: 10px;
    padding: 27px 0 0 29px;
  }
  .info_ {
    background-color: #fff;
    padding: 27px 0 0 29px;
    width: 100%;
    height: 229px;
    border-radius: 10px;
    // margin-top: 20px;
    .bottom_ {
      display: flex;
      // justify-content: space-around;
      // width: 580px;
      .card_ {
        position: relative;
        top: 0;
        color: #fff;
        width: 360px;
        height: 100%;
        .name_ {
          position: absolute;
          top: 68px;
          display: flex;
          justify-content: space-between;
          width: 360px;
          padding: 0 24px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 14px;
          &:nth-child(3) {
            top: 15px;
          }
        }
        img {
          width: 360px;
          height: 130px;
        }
        .date_ {
          position: absolute;
          bottom: 15px;
          left: 24px;
          font-size: 14px;
        }
      }

      .insurance {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 130px;
        height: 130px;
        background-color: #fafafa;
        border-radius: 10px;
        // margin-right: 30px;
        margin-left: 30px;
        .middle_ {
          text-align: center;
          margin: 2px 10px;
          font-weight: bold;
          font-size: 16px;
        }
        img {
          width: 24px;
          height: 24px;
        }
        &:hover {
          background-color: #f6f6f6;
        }
      }
      .info_1_ {
        width: 130px;
        height: 130px;
        // margin-left: 480px;
        background-color: #fafafa;
        border-radius: 10px;
      }
    }
  }
  .business_ {
    width: 100%;
    // height: 180px;
    background-color: #fff;
    border-radius: 10px;
    margin-top: 20px;
    padding: 27px 30px 7px 29px;
    .all_item_ {
      display: flex;
      margin-bottom: 20px;
      // justify-content: space-between;
      .item {
        cursor: pointer;
        width: 30%;
        padding: 15px 15px;
        background-color: #fafafa;
        display: flex;
        align-items: center;
        // justify-content: center;
        // padding-left: 15px;
        margin-right: 5%;
        &:last-child {
          margin-right: 0;
        }
        border-radius: 10px;
        &:first-child {
          margin-left: 0;
        }
        img {
          width: 36px;
          height: 36px;
        }
        .con_ {
          padding-left: 10px;
          font-size: 12px;
          // height: 36px;
          .desc_ {
            color: #999999;
          }
        }
        &:hover {
          background-color: #f6f6f6;
        }
      }
    }
  }
  .foot_ {
    width: 100%;
    height: 156px;
    background-color: #fff;
    border-radius: 10px;
    padding: 27px 0 0 29px;
    margin-top: 20px;
    .item {
      width: 360px;
      height: 64px;
      background-color: #fafafa;
      border-radius: 10px;
      &.s_text {
        width: auto;
        padding: 0 15px 0 0;
        display: inline-flex;
        align-items: center;
      }
      img {
        width: 36px;
        height: 36px;
        margin: 0px 10px 0px 16px;
        min-width: 36px;
      }
      &:hover {
        background-color: #f6f6f6;
      }
    }
  }
}
</style>

<script>
import api from "@/utils/api";
export default {
  data() {
    return {
      businessList1: [
        {
          id: "1",
          icon: require("../assets/medilinkPC/icon_1.svg"),
          txt: this.$t("claimDetails[9]"),
          desc: this.$t("claimDetails[10]"),
          path: "/Home/ClaimQuery"
        },
        {
          id: "2",
          icon: require("../assets/medilinkPC/icon_2.svg"),
          txt: this.$t("claimDetails[11]"),
          desc: this.$t("claimDetails[12]"),
          path: "/Home/ClaimApply"
        },
        {
          id: "3",
          icon: require("../assets/medilinkPC/icon_3.svg"),
          txt: this.$t("claimDetails[13]"),
          desc: this.$t("claimDetails[14]"),
          path: "/Home/ClaimUnPaidQuery"
        }
      ],
      businessList2: [
        {
          id: "4",
          icon: require("../assets/medilinkPC/icon_4.svg"),
          txt: this.$t("claimDetails[15]"),
          desc: this.$t("claimDetails[16]"),
          path: "claimGuide"
        },
        {
          id: "5",
          icon: require("../assets/medilinkPC/icon_5.svg"),
          txt: this.$t("claimDetails[17]"),
          desc: this.$t("claimDetails[18]"),
          path: "/Home/ClaimSupplement"
        },
        {
          id: "6",
          icon: require("../assets/medilinkPC/icon_6.svg"),
          txt: this.$t("claimDetails[19]"),
          desc: this.$t("claimDetails[20]"),
          path: "claimProve"
        }
      ],
      prelicensList1: [
        {
          id: "1",
          icon: require("../assets/medilinkPC/preauth1.svg"),
          txt: this.$t("preauthText[4]"),
          desc: this.$t("preauthText[5]"),
          path: "/Home/PreAuthQuery"
        },
        {
          id: "2",
          icon: require("../assets/medilinkPC/preauth2.svg"),
          txt: this.$t("preauthText[0]"),
          desc: this.$t("preauthText[1]"),
          path: "/Home/PreAuthApply"
        },
        {
          id: "3",
          icon: require("../assets/medilinkPC/preauth3.svg"),
          txt: this.$t("preauthText[6]"),
          desc: this.$t("preauthText[7]"),
          path: "/Home/PreAuthGuide"
        }
      ],
      prelicensList2: [
        {
          id: "4",
          icon: require("../assets/medilinkPC/preauth4.svg"),
          txt: this.$t("preauthText[2]"),
          desc: this.$t("preauthText[3]"),
          path: "/Home/PreAuthSupplement"
        },
        {
          id: "5",
          icon: require("../assets/medilinkPC/preauth5.svg"),
          txt: this.$t("preauthText[8]"),
          desc: this.$t("preauthText[9]"),
          path: "/Home/PreAuthProve"
        }
      ],
      name: "",
      qrCode: "",
      idValidDate: "",
      info: {},
      noticeList: [],
      data: {},
      memberNo: "",
      corpCode: "",
      account: ""
    };
  },
  filters: {
    filterCode(code) {
      return code && code.replace(/(\d{4})/g, match => match + " ");
    }
  },
  mounted() {
    this.account = localStorage.getItem("account");
    this.showEmployeeInfo();
    // this.webPersonCenterInfo()
    this.queryMessAges();
  },
  methods: {
    doPolicyApply(item) {
      if (item.path == "claimGuide") {
        this.getServiceTemplate();
      } else if (item.path == "claimProve") {
        this.getTemplate();
      } else {
        const { reimburseSumitted } = JSON.parse(
          localStorage.getItem("userInfo")
        );

        if (item.path == "/Home/ClaimApply" && reimburseSumitted == "N") {
          this.$message.info("您暂无自助理赔申请权限。如有问题，请联系客服");
          return false;
        }
        this.$router.push(item.path);
      }
    },
    doPolicyApply1(item) {
      if (item.path.indexOf("PreAuthGuide") > -1) {
        this.getServiceTemplate("1");
      } else if (item.path.indexOf("PreAuthProve") > -1) {
        this.getTemplate("1");
      } else {
        this.$router.push(item.path);
      }
    },
    getServiceTemplate(flag) {
      if (flag == "1") {
        api
          .getServiceTemplatePre({ templateType: "AUSERVICE" })
          .then(res => res.data)
          .then(data => {
            let fileUrl = "";
            let fileName = "";
            if (this.$i18n.locale == "zh-cn") {
              fileUrl = data.data[0].temPlateUrl;
              fileName = data.data[0].temPlateName;
            } else {
              fileUrl = data.data[1].temPlateUrl;
              fileName = data.data[1].temPlateName;
            }
            this.fileLinkToStreamDownload(fileUrl, fileName);
          });
      } else {
        api
          .getServiceTemplateClaim({ templateType: "LPSQ" })
          .then(res => res.data)
          .then(data => {
            let fileUrl = "";
            let fileName = "";
            if (this.$i18n.locale == "zh-cn") {
              fileUrl = data.data[0].temPlateUrl;
              fileName = data.data[0].temPlateName;
            } else {
              fileUrl = data.data[1].temPlateUrl;
              fileName = data.data[1].temPlateName;
            }
            this.fileLinkToStreamDownload(fileUrl, fileName);
          });
      }
    },
    getTemplate(flag) {
      if (flag == "1") {
        let type = "AUAPP";
        api
          .getTemplatePre({ templateType: type })
          .then(res => res.data)
          .then(data => {
            let fileUrl = "";
            let fileName = "";
            if (this.$i18n.locale == "zh-cn") {
              fileUrl = data.data[0].temPlateUrl;
              fileName = data.data[0].temPlateName;
            } else {
              fileUrl = data.data[1].temPlateUrl;
              fileName = data.data[1].temPlateName;
            }
            this.fileLinkToStreamDownload(fileUrl, fileName);
          });
      } else {
        let type = "LPSQ";
        api
          .getTemplate({ templateType: type })
          .then(res => res.data)
          .then(data => {
            let fileUrl = "";
            let fileName = "";
            if (this.$i18n.locale == "zh-cn") {
              fileUrl = data.data[0].temPlateUrl;
              fileName = data.data[0].temPlateName;
            } else {
              fileUrl = data.data[1].temPlateUrl;
              fileName = data.data[1].temPlateName;
            }
            this.fileLinkToStreamDownload(fileUrl, fileName);
          });
      }
    },
    /**
     * 文件链接转文件流下载--主要针对pdf 解决谷歌浏览器a标签下载pdf直接打开的问题
     * @param url  ：文件链接
     * @param fileName  ：文件名;
     */
    fileLinkToStreamDownload(url, fileName) {
      window.open(url);
    },
    /**
     *下载导出文件
     * @param blob  ：返回数据的blob对象或链接
     * @param tagFileName  ：下载后文件名标记
     */
    downloadExportFile(blob, tagFileName) {
      let downloadElement = document.createElement("a");
      let href = blob;
      if (typeof blob == "string") {
        downloadElement.target = "_blank";
      } else {
        href = window.URL.createObjectURL(blob); //创建下载的链接
      }
      downloadElement.href = href;
      downloadElement.download = tagFileName; //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      if (typeof blob != "string") {
        window.URL.revokeObjectURL(href); //释放掉blob对象
      }
    },
    showEmployeeInfo() {
      api
        .showEmployeeInfo()
        .then(res => res.data)
        .then(data => {
          console.log(data, "安科吉");
          let employeeInfo = data.data.filter(
            item => item.Card_no == this.account
          )[0];
          if (employeeInfo) {
            this.name = employeeInfo.Employee_name;
            this.qrCode = employeeInfo.Card_no;
            this.idValidDate = employeeInfo.startDate;
            this.memberNo = employeeInfo.memberNo;
            localStorage.setItem("memberNo", this.memberNo);
            this.corpCode = employeeInfo.Corp_code;
            localStorage.setItem("corpCode", this.corpCode);
          } else {
            employeeInfo = data.data[0];
            this.name = employeeInfo.Employee_name;
            this.qrCode = employeeInfo.Card_no;
            this.idValidDate = employeeInfo.startDate;
            this.memberNo = employeeInfo.memberNo;
            localStorage.setItem("memberNo", this.memberNo);
            this.corpCode = employeeInfo.Corp_code;
            localStorage.setItem("corpCode", this.corpCode);
          }
          let userInfo = {
            payorCode: employeeInfo.Payor_code,
            Employee_name: employeeInfo.Employee_name,
            isMgu: employeeInfo.is_mgu,
            isMainCard: employeeInfo.isMainCard,
            cardNo: employeeInfo.Card_no,
            reimburseSumitted: employeeInfo.Reimburse_sumitted
          };
          localStorage.setItem("userInfo", JSON.stringify(userInfo));
          localStorage.setItem("baseInfo", JSON.stringify(this.employeeInfo));
          this.$CardList(data.data);
        });
    },
    queryMessAges() {
      let param = {
        status: "0",
        type: "1"
      };
      api
        .queryMessAges(param)
        .then(res => res.data)
        .then(data => {
          this.noticeList = data.data;
          this.noticeList = [
            {
              id: "43",
              titleSecond: "通知",
              type: 1,
              title: "苏哲的通知",
              content: "责任内金额￥798.85，100%赔付。",
              status: 0,
              sendTime: "2018-10-17 11:07:05"
            }
          ];
        });
    },
    webPersonCenterInfo() {
      api
        .webPersonCenterInfo({ language: "CHINAESE" })
        .then(res => res.data)
        .then(data => {
          this.info = data.data;
          localStorage.setItem("baseInfo", JSON.stringify(this.info));
        });
    },
    toHospital() {
      this.$router.push({
        name: "HospitalList"
      });
    },
    toSubscribe() {
      this.$router.push({
        name: "SubscribeLists"
      });
    }
  }
};
</script>
